__webpack_require__.p = "https://ikea.marat.qd.je/se/sv/customer-service/support/";